import {LAYERINFORMATION} from './LayerInformationTypes'

const initialState = {
    layerInformation : ""
}

const LayerInformationReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case LAYERINFORMATION:
            
            return {
                layerInformation : action.load
            }
    
        default:
          return state
    }

}

export default LayerInformationReducer;